import templateUrl from './page-status.html';

export const pageStatusComponent = {
	bindings:{
		list: '<',
		onChange: '&'
	},

	templateUrl,

	controller: class PageStatusComponent {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/page-status/page-status.component.js